import React from 'react';
import { format } from 'date-fns';
import IconText from '../IconText';
import { t } from '../../../utils/i18n';
import Paragraph from '../../elements/Paragraph';
import Spacing from '../Spacing';

interface TripsAvailableProps {
  date: string;
  small?: boolean;
}

const TripsAvailable: React.FunctionComponent<TripsAvailableProps> = ({
  date,
  small
}) => {
  return (
    <div className="trips-available" data-testid="availability-date">
      <IconText
        icon="travel-calendar"
        iconSize={small ? 2 : [2, 2, 3]}
        iconColor="gray"
        data-testid="travel-date"
      >
        <Spacing top={[0.25, 0.25, small ? 0 : 0.25]}>
          <Paragraph small={small}>
            {t('Matkoja saatavilla')} {format(new Date(date), 'dd.MM.yyyy')}{' '}
            {t('alkaen.')}
          </Paragraph>
        </Spacing>
      </IconText>
    </div>
  );
};

export default TripsAvailable;
